export default __webpack_public_path__ + "static/media/hero-bg-mobile.61a93cd0.png";